import { noop } from 'lodash';

import { PrescriptionStatusForContinuouslyUsedMedicines } from '@dreryk/egabinet-visit-frontend-api';

import { StandardSpinner, UncontrolledCheckbox } from '@dreryk/react-components';

import { ContinuouslyUsedMedicinesPrescriptionStatus } from '../../VisitContinuouslyUsedMedicineTable';

type VisitContinuouslyUsedMedicineTableCheckboxProps = {
   readonly isReadonly?: boolean;
   readonly prescriptionStatus: PrescriptionStatusForContinuouslyUsedMedicines;
   readonly handleChange: VoidFunction | null;
   readonly requestLoading: boolean;
   readonly medicineId: number;
};

const VisitContinuouslyUsedMedicineTableCheckbox = (
   props: VisitContinuouslyUsedMedicineTableCheckboxProps
): JSX.Element => {
   if (props.requestLoading) {
      return <StandardSpinner />;
   }

   return (
      <UncontrolledCheckbox
         id={props.medicineId.toString()}
         name={props.medicineId.toString()}
         selected={props.prescriptionStatus === ContinuouslyUsedMedicinesPrescriptionStatus.DRAFT}
         onSelectionChange={props.handleChange ?? noop}
         disabled={props.isReadonly}
         testId={String(props.medicineId)}
      />
   );
};
export { VisitContinuouslyUsedMedicineTableCheckbox };
